module.exports = __webpack_public_path__ + "images/logo/magi_logo_0800387981461e8888f104c1050ee2f2.png";